import IntercomSDK from "@intercom/messenger-js-sdk"

let intercomInitialized = false

export function initializeIntercom() {
  if (
    typeof window.intercomSettings === "undefined" ||
    !window.intercomSettings
  ) {
    return
  }

  if (intercomInitialized) {
    // If already initialized, just update with new settings
    updateIntercom(window.intercomSettings)
    return
  }

  try {
    // Use the SDK for first-time initialization only
    // The SDK will set up the script and handle subsequent updates internally
    IntercomSDK(window.intercomSettings)
    intercomInitialized = true
  } catch (error) {
    console.error("Failed to initialize Intercom:", error)
  }
}

export function updateIntercom(settings = {}) {
  if (!intercomInitialized) {
    return
  }

  try {
    // Use the global Intercom function for commands
    window.Intercom("update", settings)
  } catch (error) {
    console.error("Failed to update Intercom:", error)
  }
}

export function showIntercom() {
  if (!intercomInitialized) {
    return
  }

  try {
    window.Intercom("show")
  } catch (error) {
    console.error("Failed to show Intercom:", error)
  }
}

export function showNewMessage(message) {
  if (!intercomInitialized) {
    return
  }

  try {
    window.Intercom("showNewMessage", message)
  } catch (error) {
    console.error("Failed to show new Intercom message:", error)
  }
}

export function hideIntercom() {
  if (!intercomInitialized) {
    return
  }

  try {
    window.Intercom("hide")
  } catch (error) {
    console.error("Failed to hide Intercom:", error)
  }
}

export function shutdownIntercom() {
  if (!intercomInitialized) {
    return
  }

  try {
    window.Intercom("shutdown")
    intercomInitialized = false
  } catch (error) {
    console.error("Failed to shutdown Intercom:", error)
  }
}
